import React from "react";
import { CellRenderFunction, ButtonCellValue } from "@getregistered/greg-editors/";
import { ActionMenuCellAdapter, CellRendererPrimer } from "@getregistered/greg-editors";
// @ts-ignore
import { Table } from "@primer/react/experimental";
import { RegistrationCheckPoint } from "./types";
import { CheckinCell } from "./CheckinCell";

export const renderCheckinCellPrimer: CellRenderFunction = ({ row, column }) => {
  if (column.type === "checkpoint") {
    const checkPoint = row[column.key] as RegistrationCheckPoint;
    if (checkPoint.attending) {
      return (
        <CheckinCell
          key={[row.id, column.key].join("-")}
          checkPoint={checkPoint}
        />
      );
    } else {
      return (
        <Table.Cell>
          <span>Not attending</span>
        </Table.Cell>
      );
    }
  }
  if (column.key === "action_menu" && (row.action_menu as ButtonCellValue)?.buttons) {
    return (
      <Table.Cell>
        <ActionMenuCellAdapter buttons={(row.action_menu as ButtonCellValue).buttons as any} />
      </Table.Cell>
    );
  }
  return <CellRendererPrimer row={row} column={column} />;
};

export const createRenderCheckinCellPrimer = (handleReload: () => void): CellRenderFunction => {
  return ({ row, column }) => {
    if (column.type === "checkpoint") {
      const checkPoint = row[column.key] as RegistrationCheckPoint;
      if (checkPoint.attending) {
        return (
          <CheckinCell
            key={[row.id, column.key].join("-")}
            checkPoint={checkPoint}
            onReload={handleReload}
          />
        );
      } else {
        return (
          <Table.Cell>
            <span>Not attending</span>
          </Table.Cell>
        );
      }
    }
    if (column.key === "action_menu" && (row.action_menu as ButtonCellValue)?.buttons) {
      return (
        <Table.Cell>
          <ActionMenuCellAdapter buttons={(row.action_menu as ButtonCellValue).buttons as any} />
        </Table.Cell>
      );
    }
    return <CellRendererPrimer row={row} column={column} />;
  };
};

